function UserFormsCheckout(form, callback) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "json",
        cache: false,
        success: function (dt) {
            callback(dt);
        },
        error: function () {
            callback(getStandartMessages("BirHataOlustu"));
        }
    });
}

function SendSmsCode(form, data, callback) {
    $.ajax({
        type: "POST",
        url: getRequestRoute() + "/p/User/SendSmsCode",
        cache: false,
        data: data,
        beforeSend: function () {
            GenerateLocalLoading(form, "show");
        },
        complete: function () {
            GenerateLocalLoading(form, "hide");
        },
        success: function (dt) {
            callback(true, dt);
        },
        error: function () {
            callback(false, null);
        }
    });
}